export default "__VITE_ASSET__b2a16af8__"